export default defineNuxtRouteMiddleware(() => {
	const { role } = useAuth<User>()
	if (role.value == 'admin') return
	return abortNavigation()
})
